/* Our Story — shared scroll behaviour.
   One IntersectionObserver for reveals across all sections, plus the timeline
   thread line-draw. Behaviour matches the approved prototypes; all motion is
   gated behind prefers-reduced-motion.

   The certification rail's dot indicator used to live here too. The rail now
   uses the shared certification panels, which carry a swipe hint instead, so
   it had no consumer left.

   Note for the arithmetic share bars in story-math-of-rest: they animate off
   .sty-arith gaining .is-visible, and the reduce branch below still adds that
   class. That is deliberate — under reduced motion the bars appear at their
   final width rather than never appearing at all.

   All seven sections reference this file. The browser executes it once (same
   src), and every binding is guarded by a data-*-bound attribute so re-running
   it is safe. It is re-run on shopify:section:load, because the theme editor
   re-renders a section's markup without re-executing an already-loaded script —
   without that, a freshly added section's [data-reveal] elements would stay at
   opacity 0. */
(function () {
  function init(root) {
    var scope = root || document;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.innerWidth <= 749;

    /* ---- reveals -------------------------------------------------------- */
    var els = scope.querySelectorAll('[data-reveal]:not([data-reveal-bound])');

    if (reduce) {
      els.forEach(function (el) {
        el.setAttribute('data-reveal-bound', '');
        el.classList.add('is-visible');
      });
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: mobile ? 0.12 : 0.15 }
      );

      els.forEach(function (el) {
        el.setAttribute('data-reveal-bound', '');
        io.observe(el);
      });
    }

    /* ---- timeline thread: draw the line once on scroll into view -------- */
    if (!reduce) {
      scope
        .querySelectorAll('[data-thread-path]:not([data-thread-bound])')
        .forEach(function (path) {
          path.setAttribute('data-thread-bound', '');

          var timeline = path.closest('[data-timeline]');
          if (!timeline) return;

          var len = path.getTotalLength();
          if (!len) return;

          path.style.strokeDasharray = len;
          path.style.strokeDashoffset = len;
          /* Force reflow so the transition runs from the dashed state. */
          path.getBoundingClientRect();

          var tio = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  path.style.strokeDashoffset = '0';
                  tio.unobserve(entry.target);
                }
              });
            },
            { threshold: mobile ? 0.08 : 0.12 }
          );

          tio.observe(timeline);
        });
    }

  }

  init(document);

  /* Theme editor: bind whatever the merchant just added or re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
